<script setup lang="ts">
  import menuKebabIcon from '@/shared/assets/icons/menuKebabIcon.svg';
  import MenuKebab2Icon from '@/shared/assets/icons/MenuKebab2Icon.svg';
  import { IconImage } from '@/shared/ui';
  import { computed } from 'vue';

  interface Props {
    direction: 'row' | 'column';
    index: number;
    isVisible: boolean;
    isSelected: boolean;
    style: Record<string, string | undefined>;
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{
    (e: 'select', index: number, event: MouseEvent): void;
  }>();

  const icon = computed(() => (props.direction === 'row' ? MenuKebab2Icon : menuKebabIcon));
  const tooltipContent = computed(() =>
    props.direction === 'row' ? 'Selecionar linha' : 'Selecionar coluna'
  );
</script>

<template>
  <button
    v-tippy="{
      content: tooltipContent,
      placement: 'top',
      theme: 'custom',
      trigger: 'mouseenter',
      hideOnClick: true,
      interactive: false,
    }"
    type="button"
    class="table-select-line-button"
    :class="[direction, { 'is-visible': isVisible, 'is-selected': isSelected }]"
    :style="style"
    :aria-label="tooltipContent"
    @click="emit('select', index, $event)"
  >
    <IconImage
      :src="icon"
      :alt="tooltipContent"
    />
  </button>
</template>

<style scoped>
  .table-select-line-button {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-white-01);
    border: 1px solid var(--color-gray-02);
    border-radius: 8px;
    cursor: pointer;
    pointer-events: none;
    opacity: 0;
    transition:
      opacity 0.15s ease,
      background-color 0.15s ease,
      border-color 0.15s ease;
    padding: 0;
  }

  .table-select-line-button.row {
    left: 0;
    height: 25px;
    color: var(--color-gray-07);
  }

  .table-select-line-button.column {
    top: 0;
    height: 22px;
  }

  .table-select-line-button:hover {
    background-color: var(--color-gray-12);
    border-color: #d0d0d0;
  }

  .table-select-line-button.is-visible {
    opacity: 1;
    pointer-events: auto;
  }

  .table-select-line-button.is-selected {
    opacity: 1;
    pointer-events: auto;
    background-color: var(--color-gray-02);
  }

  .table-select-line-button :deep(svg) {
    flex-shrink: 0;
  }
</style>
